import {
  Button,
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import { MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { ClassificacaoStore } from "../../stores/classificacao/ClassificacaoStore";
import ClassificacaoItensDetail from "./ClassificacaoItensDetail";
import { PagerResultados } from "../utils/PagerResultados";
import { toast } from "react-toastify";
import { Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem, TextField, Typography } from "@mui/material";
import { AppIcon } from "../utils/AppIcon";

interface ClassificacaoDetailProps { }

interface ClassificacaoDetailState { }

@observer
export default class ClassificacaoDetail extends React.Component<ClassificacaoDetailProps, ClassificacaoDetailState> {

  obs = observable({})

  constructor(props) {
    super(props);
  }

  handleClassificarTodos() {
    ClassificacaoStore.selectAllClassificarLote();
    ClassificacaoStore.obs.classificar_todos = true;
  }

  async handleBuscaDetalhamento(e) {
    ClassificacaoStore.obs.textFilter = e;

    if (e === "") {
      ClassificacaoStore.resetClassificarItems();
    }

    await ClassificacaoStore.query(ClassificacaoStore.obs.selectedEmpresa, [ClassificacaoStore.obs.date_start, ClassificacaoStore.obs.date_end], e, 1, ClassificacaoStore.obs.chave)

  }

  async handleClassificar(classificacao: string) {

    if (classificacao == "REVENDA") {

      await ClassificacaoStore.classificacao_revenda(ClassificacaoStore.obs.classificarItems?.map(value => value["id"]), ClassificacaoStore.obs.selectedEmpresa.cnpj)

    } else {

      let calc_id = null

      const itemOne = ClassificacaoStore.obs.classificarItems[0]

      const estadual = itemOne.uf_origem === itemOne.uf_destino

      let calcs = await ClassificacaoStore.loadCalcs();

      const calcEncontrado = ClassificacaoStore.handleBuscaCalculo(calcs, estadual, classificacao)

      if (calcEncontrado) {

        calc_id = calcEncontrado._id;

      } else {

        toast.error("Nenhum Cálculo encotrado, contate o suporte!", {});
        return

      }

      let params = {
        nota_item_ids: ClassificacaoStore.obs.classificarItems?.map(value => value["id"]),
        contestacao_data: null,
        motivo: `Classificação de itens para ${classificacao}`,
        contestacao_calc_id: calc_id,
        entrada_saida: "entrada",
        modelo: "nf-e",
      }

      await ClassificacaoStore.create_classificacao_task(params, ClassificacaoStore.obs.selectedEmpresa.uf, classificacao)

    }

  }

  async handlePageChange(page: number) {
    ClassificacaoStore.obs.current_page = page

    await ClassificacaoStore.query(
      ClassificacaoStore.obs.selectedEmpresa,
      [ClassificacaoStore.obs.date_start, ClassificacaoStore.obs.date_end],
      ClassificacaoStore.obs.textFilter,
      ClassificacaoStore.obs.current_page,
      ClassificacaoStore.obs.chave)
  }

  render() {
    let selectedSelectedCaption = ClassificacaoStore.obs.classificarItems.length == 1 ? "selecionado" : "selecionados";
    let selectedItemCaption = ClassificacaoStore.obs.classificarItems.length == 1 ? "item" : "itens";

    const ClassificacaoCell = ({ handleClassificar }) => {
      const [anchorEl, setAnchorEl] = React.useState(null);
      const [query, setQuery] = React.useState("");
      const inputRef = React.useRef(null);

      const open = Boolean(anchorEl);

      const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
        setQuery("");
      };

      const handleClose = () => setAnchorEl(null);

      const handleSelect = (id) => {
        handleClassificar(id);
        handleClose();
      };

      React.useEffect(() => {
        if (open) setTimeout(() => inputRef.current?.focus(), 0);
      }, [open]);

      const filtered = React.useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return ClassificacaoStore.options();
        return ClassificacaoStore.options().filter((o) => o.name.toLowerCase().includes(q));
      }, [query]);

      return (
        <div>
          <Button
            className="btnContestar"
            intent="primary"
            onClick={handleOpen}
            disabled={ClassificacaoStore.obs.classificarItems.length == 0}
            icon="issue"
          >
            {`Classificar ${ClassificacaoStore.obs.classificarItems.length} ${selectedItemCaption} ${selectedSelectedCaption}`}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            disableAutoFocusItem
          >
            <Box>
              <TextField
                inputRef={inputRef}
                size="small"
                fullWidth
                placeholder="Buscar classificação…"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Escape") handleClose();
                }}
              />
            </Box>

            <Divider />

            <Box sx={{ maxHeight: 300, overflow: "auto", py: 0.5 }}>
              {filtered.length === 0 ? (
                <Typography variant="body2" sx={{ p: 2, opacity: 0.75 }}>
                  Nenhum resultado para “{query}”.
                </Typography>
              ) : (
                filtered.map((x) => (
                  <MenuItem key={x.id || x.name} onClick={() => handleSelect(x.id)} dense>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <AppIcon name={x.icon || "help"} color="#000" />
                    </ListItemIcon>

                    <ListItemText
                      primary={x.name}
                      primaryTypographyProps={{ noWrap: true, title: x.name }}
                    />
                  </MenuItem>
                )))}
            </Box>
          </Menu>
        </div>
      );
    }

    return (
      <>
        <MDBRow>
          <MDBCol md="4">
            <FormGroup
              label="Busca de Detalhamento"
              className="nz-horizontal-field"
            >
              <InputGroup
                placeholder="Filtrar (Descrição)"
                value={ClassificacaoStore.obs.textFilter}
                style={{ borderRadius: 10 }}
                onChange={(e) => this.handleBuscaDetalhamento(e.target.value)}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="4">
            <div style={{ float: "left" }}>
              <ClassificacaoCell handleClassificar={this.handleClassificar.bind(this)} />
            </div>
          </MDBCol>

          <MDBCol md="4">
            <div style={{ float: "right", marginTop: 25 }}>
              <Button
                text="Atualizar"
                intent="primary"
                onClick={() => this.handlePageChange(ClassificacaoStore.obs.current_page)}
                loading={ClassificacaoStore.obs.loading_itens}
              />
            </div>
          </MDBCol>

        </MDBRow>

        <ClassificacaoItensDetail items={ClassificacaoStore.obs.results} />

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <PagerResultados
            currentPage={ClassificacaoStore.obs.current_page}
            totalCount={ClassificacaoStore.obs.length_itens}
            onPageChange={(pager) => this.handlePageChange(pager)}
            pageSize={15}
          />
        </div>
      </>
    );
  }
}
